// the mismatch of latestAmountFetchTime and requestedTime means there's other requests issued
// during the fetch time. Discard the response since it no longer contains the correct amount
export function requestMatchesResponse(requestTime, responseTime) {
  return requestTime.toString() === responseTime.toString()
}
